/**
 * Reparto de los banners de la portada en sus tres filas (ADM-05).
 *
 * La API entrega una sola lista, ya ordenada; la portada y el panel la parten
 * por `ubicacion` con esta misma funcion, para que los dos vean las filas
 * igual. Es una funcion pura: no toca React ni el navegador.
 */
import type { Banner, UbicacionBanner } from '@bandu/compartido';

export type FilasDeBanners = Record<UbicacionBanner, Banner[]>;

/** Las tres filas en el orden en que aparecen en la portada. */
export const UBICACIONES: readonly UbicacionBanner[] = ['carrusel', 'promociones', 'cuadros'];

/** Como se nombra cada fila en el backoffice. */
export const NOMBRE_UBICACION: Record<UbicacionBanner, string> = {
  carrusel: 'Carrusel principal',
  promociones: 'Fila de promociones',
  cuadros: 'Cuadros con titulo',
};

export function agruparBanners(banners: readonly Banner[]): FilasDeBanners {
  const filas: FilasDeBanners = { carrusel: [], promociones: [], cuadros: [] };
  for (const banner of banners) filas[banner.ubicacion].push(banner);
  return filas;
}
